@if (link && preparedLink && !preparedLink.urlObject) {
  <a
    [attr.id]="id"
    [routerLink]="[preparedLink.url] | localize"
    [class]="'link-button ' + class"
  >
    {{ text | translate }}
  </a>
}
@if (link && preparedLink && preparedLink.urlObject) {
  <a [attr.id]="id" [href]="preparedLink.url" [class]="'link-button ' + class">
    {{ text | translate }}
  </a>
}
@if (!link) {
  <a [attr.id]="id" [class]="'link-button ' + class">
    {{ text | translate }}
  </a>
}
